export default __webpack_public_path__ + "static/media/dream_text_back.15286a8e.gif";